import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

export default function BlogPreview() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/posts").then((res) => setPosts(res.data.slice(0, 3))).catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section id="journal" data-testid="blog-preview" className="relative z-10 py-24 md:py-32 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary mb-4">/ The Journal</p>
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl">
              Notes on wealth
            </h2>
          </div>
          <Link
            data-testid="blog-preview-all"
            to="/blog"
            className="font-mono-accent text-xs uppercase tracking-[0.2em] text-foreground hover:text-primary transition-colors inline-flex items-center gap-2"
          >
            Read the journal <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border">
          {posts.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              className="bg-background"
            >
              <Link data-testid={`blog-preview-card-${i}`} to={`/blog/${p.slug}`} className="group block p-6 sm:p-8 h-full hover:bg-card transition-colors">
                <div className="aspect-[16/10] overflow-hidden mb-6 border border-border">
                  <img
                    src={p.cover_image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="flex items-center gap-3 font-mono-accent text-[11px] uppercase tracking-[0.15em] text-primary mb-3">
                  <span>{p.category}</span>
                  <span className="text-muted-foreground">— {p.read_time}</span>
                </div>
                <h3 className="font-display font-extrabold uppercase tracking-tight text-xl sm:text-2xl leading-tight group-hover:text-primary transition-colors">
                  {p.title}
                </h3>
                <p className="text-muted-foreground text-sm mt-3 leading-relaxed line-clamp-2">{p.excerpt}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
